import { GENRES, REGIONS, YEAR_RANGES } from '@/mocks/movies';

export interface FilterState {
  regions: string[];
  yearLabel: string | null;
  genres: string[];
}

interface FilterPanelProps {
  state: FilterState;
  onToggleRegion: (region: string) => void;
  onSelectYear: (label: string | null) => void;
  onToggleGenre: (genre: string) => void;
  onReset: () => void;
}

function Chip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 h-8 flex items-center rounded-full text-xs font-medium whitespace-nowrap cursor-pointer border transition-colors ${
        active
          ? 'bg-primary-500 border-primary-500 text-background-950'
          : 'bg-background-100 border-background-200 text-foreground-600 hover:border-primary-400 hover:text-foreground-900'
      }`}
    >
      {children}
    </button>
  );
}

export default function FilterPanel({
  state,
  onToggleRegion,
  onSelectYear,
  onToggleGenre,
  onReset,
}: FilterPanelProps) {
  const hasActive =
    state.regions.length > 0 || state.yearLabel !== null || state.genres.length > 0;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-xs font-semibold text-foreground-500 mb-2">按地区</h3>
        <div className="flex flex-wrap gap-2">
          {REGIONS.map((region) => (
            <Chip
              key={region}
              active={state.regions.includes(region)}
              onClick={() => onToggleRegion(region)}
            >
              {region}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-foreground-500 mb-2">按年份</h3>
        <div className="flex flex-wrap gap-2">
          {YEAR_RANGES.map((range) => (
            <Chip
              key={range.label}
              active={state.yearLabel === range.label}
              onClick={() => onSelectYear(state.yearLabel === range.label ? null : range.label)}
            >
              {range.label}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-foreground-500 mb-2">按类型</h3>
        <div className="flex flex-wrap gap-2">
          {GENRES.map((genre) => (
            <Chip
              key={genre}
              active={state.genres.includes(genre)}
              onClick={() => onToggleGenre(genre)}
            >
              {genre}
            </Chip>
          ))}
        </div>
      </div>

      {hasActive && (
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-500 hover:text-accent-500 cursor-pointer transition-colors"
        >
          <i className="ri-refresh-line"></i>
          重置全部筛选条件
        </button>
      )}
    </div>
  );
}